import React, { useState } from 'react';
import { Star } from 'lucide-react';

const LABELS = {
  1: 'Muy Insatisfecho',
  2: 'Insatisfecho',
  3: 'Neutral',
  4: 'Satisfecho',
  5: 'Excelente'
};

const Rating5 = ({ value, onChange, disabled }) => {
  const [hovered, setHovered] = useState(0);

  return (
    <div className="flex flex-col items-center py-4">
      <div className="flex items-center gap-3 sm:gap-4 my-2">
        {[1, 2, 3, 4, 5].map((star) => {
          const isActive = (hovered || value) >= star;
          return (
            <button
              key={star}
              type="button"
              disabled={disabled}
              onMouseEnter={() => setHovered(star)}
              onMouseLeave={() => setHovered(0)}
              onClick={() => onChange(star)}
              className="p-2 transition-transform duration-200 transform hover:scale-125 focus:outline-none cursor-pointer"
              aria-label={`Calificación ${star} de 5`}
            >
              <Star
                size={40}
                className={`transition-colors duration-200 ${
                  isActive
                    ? 'fill-amber-400 text-amber-500 drop-shadow-md'
                    : 'text-slate-300 hover:text-amber-200'
                }`}
              />
            </button>
          );
        })}
      </div>
      
      <div className="h-6 mt-1">
        {(hovered || value) ? (
          <span className="text-sm font-semibold text-adium-red animate-fadeIn">
            {LABELS[hovered || value]}
          </span>
        ) : (
          <span className="text-xs text-slate-400">Selecciona una calificación</span>
        )}
      </div>
    </div>
  );
};

export default Rating5;
